var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarEnabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.50894 16.6837C3.08727 16.6837 2.73037 16.5401 2.43822 16.2529C2.14607 15.9658 2 15.6149 2 15.2005V4.21874C2 3.80426 2.14607 3.45344 2.43822 3.16627C2.73037 2.8791 3.08727 2.73552 3.50894 2.73552H4.66459V1H5.94878V2.73552H12.2734V1H13.5254V2.73552H14.6811C15.1027 2.73552 15.4596 2.8791 15.7518 3.16627C16.0439 3.45344 16.19 3.80426 16.19 4.21874V15.2005C16.19 15.6149 16.0439 15.9658 15.7518 16.2529C15.4596 16.5401 15.1027 16.6837 14.6811 16.6837H3.50894ZM3.50894 15.453H14.6811C14.7453 15.453 14.8042 15.4266 14.8576 15.374C14.9112 15.3215 14.9379 15.2636 14.9379 15.2005V7.50066H3.25206V15.2005C3.25206 15.2636 3.27884 15.3215 3.3324 15.374C3.38582 15.4266 3.44467 15.453 3.50894 15.453ZM3.25206 6.26994H14.9379V4.21874C14.9379 4.15557 14.9112 4.09772 14.8576 4.04521C14.8042 3.99256 14.7453 3.96624 14.6811 3.96624H3.50894C3.44467 3.96624 3.38582 3.99256 3.3324 4.04521C3.27884 4.09772 3.25206 4.15557 3.25206 4.21874V6.26994Z",
    fill: "#199FAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarEnabled);
export default __webpack_public_path__ + "static/media/calendarEnabled.98a39527e45fccb6a339727db54baf32.svg";
export { ForwardRef as ReactComponent };